import { CurrentUserSelector } from "@nerdjs/account-kit";
import { useEffect, useRef } from "react";
import { useAppSelector } from "../hooks";
import { useUpdateTalentMutation } from "../../redux/talent/talentEndpoints";
import { useTalents } from "../../redux/talent/talentHooks";

const normalize = (value?: string) => (value ?? "").trim().toLowerCase();

export function useSyncCurrentUserTalentUuid() {
  const currentUser = useAppSelector(CurrentUserSelector);
  const { talents } = useTalents();
  const [updateTalent] = useUpdateTalentMutation();
  const updatedKeysRef = useRef<Record<string, boolean>>({});

  useEffect(() => {
    const userUUID = currentUser?.uuid;
    const userFirstName = normalize(currentUser?.firstName);
    const userLastName = normalize(currentUser?.lastName);

    if (!userUUID || !userFirstName || !userLastName || !talents?.length) {
      return;
    }

    const matchingTalents = talents.filter((talent) => {
      return (
        normalize(talent.firstName) === userFirstName &&
        normalize(talent.lastName) === userLastName
      );
    });

    matchingTalents.forEach((talent) => {
      const key = `${talent.id}:${userUUID}`;
      if (updatedKeysRef.current[key]) return;
      if ((talent.userUUID ?? "").trim()) return;

      updatedKeysRef.current[key] = true;
      updateTalent({
        id: talent.id,
        body: {
          userUUID,
        },
      });
    });
  }, [currentUser, talents, updateTalent]);
}

export function SyncCurrentUserTalentUuid() {
  useSyncCurrentUserTalentUuid();
  return null;
}
